
import { convertUCWordsOrCamelCaseToDashCase, smoothScrollToTargetId } from '~/helpers/util'

export default {
  name: 'OrganismMenuBar',
  data() {
    return {
      isScrolled: false
    }
  },
  mounted() {
    this.isScrolled = window.scrollY > 40
    document.addEventListener('scroll', this.initScrollListener)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.initScrollListener)
  },
  methods: {
    initScrollListener() {
      this.isScrolled = window.scrollY > 40
    },
    scrollTopMethod() {
      const sections = this.$parent.sections
      if (sections && sections.length > 1) {
        const targetSection = sections[0]
        const targetString = convertUCWordsOrCamelCaseToDashCase(targetSection.type)
        smoothScrollToTargetId(`#${targetString}`)
      }
    }
  }
}
